export let ActionTypes = {};
ActionTypes.empty = 0;
ActionTypes.start = 1;
ActionTypes.cancel = 2;
ActionTypes.success = 3;
ActionTypes.failure = 4;
ActionTypes[ActionTypes.empty] = "empty";
ActionTypes[ActionTypes.start] = "start";
ActionTypes[ActionTypes.cancel] = "cancel";
ActionTypes[ActionTypes.success] = "success";
ActionTypes[ActionTypes.failure] = "failure";
